document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const revealPage = () => document.body.classList.add('o404-loaded');
  if (document.readyState === 'complete') revealPage();
  else window.addEventListener('load', revealPage, { once: true });
  window.setTimeout(revealPage, 700);

  if (prefersReducedMotion) {
    document.documentElement.classList.add('reduce-motion');
    return;
  }

  // Reveal editorial sections and product/category cards as they enter the viewport.
  const revealTargets = document.querySelectorAll(
    '.section-head, .category-card, .product-card, .story-copy > *, .story-image, .benefit-grid > div, .footer-grid > div, .product-page > *'
  );

  revealTargets.forEach((el, index) => {
    el.classList.add('o404-reveal');
    el.style.setProperty('--reveal-delay', `${Math.min((index % 4) * 70, 210)}ms`);
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });

    revealTargets.forEach((el) => observer.observe(el));
  } else {
    revealTargets.forEach((el) => el.classList.add('is-visible'));
  }

  // Subtle hero motion: image drift + oversized 404 parallax.
  const hero = document.querySelector('.hero-outlier');
  if (hero) {
    let ticking = false;
    const updateHero = () => {
      const rect = hero.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, -rect.top / Math.max(rect.height, 1)));
      hero.style.setProperty('--hero-shift', `${progress * 26}px`);
      hero.style.setProperty('--hero-404-shift', `${progress * -42}px`);
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHero);
        ticking = true;
      }
    };
    updateHero();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Desktop-only premium magnetic nudge for CTAs.
  if (window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.button').forEach((button) => {
      button.addEventListener('mousemove', (event) => {
        const rect = button.getBoundingClientRect();
        const x = (event.clientX - rect.left - rect.width / 2) * 0.08;
        const y = (event.clientY - rect.top - rect.height / 2) * 0.08;
        button.style.setProperty('--mag-x', `${x}px`);
        button.style.setProperty('--mag-y', `${y}px`);
      });
      button.addEventListener('mouseleave', () => {
        button.style.setProperty('--mag-x', '0px');
        button.style.setProperty('--mag-y', '0px');
      });
    });
  }
})();
